
import { motion } from "framer-motion";
import { HugeiconsIcon } from "@hugeicons/react";
import { Package01Icon } from "@hugeicons/core-free-icons";
import productImage from "../../assets/product-main.webp";
import { ShinyButton } from "../ui/shiny-button";
import { GlowyCard, GlowyCardHeader, GlowyCardPrice, GlowyCardFeatures } from "../ui/glowy-card";
import { AnimatedText } from "../ui/animated-text";
import { AnimatedImage } from "../ui/animated-image";

export function ProductGrid() {
    return (
        <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6">
            <div className="container mx-auto max-w-4xl">
                <div className="mb-8 sm:mb-12 md:mb-16 text-left sm:text-center">
                    <AnimatedText
                        lines={["Die TBOX Komplettlösung"]}
                        className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6"
                        direction="up"
                        as="h2"
                    />
                    <p className="text-base sm:text-lg md:text-xl text-gray-400 max-w-2xl mx-auto sm:mx-auto px-2 text-balance">
                        Alles was Sie für TSE-Compliance benötigen – TSE BOX, Taxameter, TSE-Karte und Installation – in einem Paket.
                    </p>
                </div>

                <GlowyCard className="group">
                    <div className="aspect-[16/9] mb-4 sm:mb-6 rounded-xl sm:rounded-2xl bg-gradient-to-br from-gray-800 to-black overflow-hidden relative">
                        <AnimatedImage
                            src={productImage}
                            alt="TBOX Komplettlösung"
                            className="w-full h-full group-hover:scale-105 transition-transform duration-700"
                        />
                    </div>
                    <p className="text-xs sm:text-sm text-gray-300 text-center mb-6 sm:mb-8 italic">
                        Das fertige Produkt kann leicht von der Darstellung abweichen
                    </p>

                    <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-6 sm:mb-8">
                        <div>
                            <GlowyCardHeader
                                icon={<HugeiconsIcon icon={Package01Icon} size={18} className="text-emerald-400/60" strokeWidth={2} />}
                                title="TBOX"
                                subtitle="Sofort verfügbare TSE-Lösung"
                            />
                            <p className="text-sm sm:text-base text-gray-400 leading-relaxed text-balance">
                                Die TBOX ist Ihre sofort verfügbare Lösung für TSE-Compliance.
                                Professionelle Qualität für maximale Zuverlässigkeit im täglichen Taxibetrieb.
                            </p>
                        </div>
                        <div>
                            <h4 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-white text-balance">Im Paket enthalten:</h4>
                            <GlowyCardFeatures
                                features={[
                                    "TBOX Hardware",
                                    "Digitax F1 Taxameter",
                                    "TSE-Karte (5 Jahre gültig)",
                                    "Professionelle Installation"
                                ]}
                            />
                        </div>
                    </div>

                    <div className="pt-4 sm:pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-center gap-4">
                        <div className="flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full bg-green-500/20 border border-green-500/50">
                            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                            <span className="text-xs sm:text-sm font-bold text-green-400 uppercase tracking-widest">Sofort lieferbar</span>
                        </div>
                    </div>
                </GlowyCard>
            </div>
        </section>
    );
}

export function ImmersiveSection() {
    return (
        <section className="relative py-16 sm:py-24 md:py-32 px-4 sm:px-6 overflow-hidden min-h-[60vh] sm:min-h-[80vh] flex items-center justify-center">
            <div className="container mx-auto flex justify-center">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="w-full"
                >
                    <GlowyCard className="text-left sm:text-center py-8 sm:py-12 md:py-16 px-4 sm:px-6">
                        <div className="mb-6 sm:mb-8">
                            <AnimatedText
                                lines={["TSE-Pflicht ist da,", "Jetzt compliant werden."]}
                                className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold tracking-tighter leading-tight"
                            />
                        </div>

                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                            viewport={{ once: true }}
                            className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-300 mb-8 sm:mb-12 max-w-2xl mx-auto sm:mx-auto leading-relaxed px-2 text-balance"
                        >
                            Seit dem <span className="text-white font-bold">1. Januar 2026</span> ist TSE für alle Taxiunternehmen <span className="text-white font-bold">verpflichtend</span>. 
                            Werden Sie jetzt compliant und vermeiden Sie Bußgelder – mit der TBOX Komplettlösung.
                        </motion.p>

                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="flex justify-start sm:justify-center"
                        >
                            <ShinyButton glow={true} className="min-h-[44px]" onClick={() => {
                                const contactSection = document.getElementById('contact');
                                if (contactSection) {
                                    contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }
                            }}>
                                Termin Vereinbaren
                            </ShinyButton>
                        </motion.div>
                    </GlowyCard>
                </motion.div>
            </div>
        </section>
    )
}
